// extracted by mini-css-extract-plugin
export default {"contactInfo":"styles_contactInfo__Yn9Uy","contactInfoContent":"styles_contactInfoContent__WKPR3","providedLabel":"styles_providedLabel__29m-P"};